import { useMemo } from 'react';

import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useAgentConceptLabels } from './useAgentConceptLabels';
import { useGetMandatoryAttributeNamesQuery } from '../../api/createProjectApiSlice';
import { type AgentConcept } from '../../state/createProjectSlice';
import { selectAddedConcepts, selectAnnotationAgentConcepts } from '../../state/selector';
import { getAgentConceptsInStep2Order } from '../../utils/getAgentConceptsInStep2Order';

// TODO: cleanup with cp_annotation_createproject_agent ff

export interface AgentConceptCardData {
  conceptGroupId: string;
  concept: AgentConcept;
  /** The concept's prompt label; null until the server has returned it. */
  alias: string | null;
  attributeLabels: string[];
}

/** One entry per step 2 concept group, in step 2 order. */
export const useAgentConceptCards = (): AgentConceptCardData[] => {
  const addedConcepts = useAppSelector(selectAddedConcepts);
  const concepts = useAppSelector(selectAnnotationAgentConcepts);
  const labels = useAgentConceptLabels();
  const { data: mandatoryAttributeNames } = useGetMandatoryAttributeNamesQuery();
  const mandatoryNames = mandatoryAttributeNames?.data;

  return useMemo(() => {
    return getAgentConceptsInStep2Order(addedConcepts, concepts).map(
      ({ conceptGroupId, concept, requiredAttributes }) => ({
        conceptGroupId,
        concept,
        alias: labels[conceptGroupId] ?? null,
        // The same labels, in the same order, as the step 2 card.
        attributeLabels: [
          ...(mandatoryNames ?? []),
          ...requiredAttributes.map((attribute) => attribute.label),
        ],
      })
    );
  }, [addedConcepts, concepts, labels, mandatoryNames]);
};
